import cs from 'date-fns/locale/cs'
import en from 'date-fns/locale/en-GB'
import React, { Suspense } from 'react'

import { registerLocale, setDefaultLocale } from 'react-datepicker'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import ErrorBoundary from './containers/ErrorBoundary'
import { AuthenticationProvider } from './context/AuthenticationContext'
import VersionChecker from './custom/components/VersionChecker/VersionChecker'
import InvoiceWrap from './custom/invoice/Invoice.wrap'
import Form from './pages/Form'
import FormList from './pages/FormList'
import LoginTest from './pages/LoginTest'
import NotFound from './pages/NotFound'
import '@fortawesome/fontawesome-free/css/all.min.css'
import './scss/main.scss'

registerLocale('cs', cs)
registerLocale('en', en)

if (window.location.pathname.startsWith('/en/')) {
  setDefaultLocale('en')
} else {
  setDefaultLocale('cs')
}

const App: React.FC = () => (
    //<React.StrictMode> //disabiling strict mode, because there are errors comming from Material-UI
    <ErrorBoundary>
        <VersionChecker/>
        <Router>
          <AuthenticationProvider>
          <Switch>
            <Route path="/:locale(cs|en)?/submission/:submissionID/invoice">
              <InvoiceWrap/>
            </Route>
            <Route path="/:locale(cs|en)?/submission/:submissionID">
              <Form/>
            </Route>
            <Route path="/:locale(cs|en)?/:organizationSlug/:formSlug">
              <Form/>
            </Route>
            <Route path="/formlist">
              <FormList/>
            </Route>
            <Route path="/logintest">
              <LoginTest/>
            </Route>
            <Route path="*">
              <Suspense fallback={'...'}>
                <NotFound/>
              </Suspense>
            </Route>
          </Switch>
          </AuthenticationProvider>
        </Router>
    </ErrorBoundary>

//</React.StrictMode>
  )


export default App
